import NotFound from 'pages/not-found';
import Redirect from 'pages/redirect';
import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import Interviews from './interviews';
import MentorshipPage from './mentees';

const MentorshipManagementRoutes: FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Redirect href="mentees/" />} />
      <Route path="/mentees/*" element={<MentorshipPage />} />
      <Route path="/interviews" element={<Interviews />} />
      <Route path="/*" element={<NotFound />} />
    </Routes>
  );
};

export default MentorshipManagementRoutes;
